import { connect } from 'react-redux';
import ComplexTopicsDisciplinesView from '../../components/complexTopicsDisciplines/ComplexTopicsDisciplinesView';
import {
  getComplexTopicsDisciplineView,
  clearComplexTopicsDisciplineView,
} from '../../actions/complexTopicsDisciplines';

const mapStateToProps = ({ complexTopicsDisciplines }, ownProps) => ({
  id_ctp: ownProps.match.params.id,
  viewData: complexTopicsDisciplines.data.view,
  viewIsLoading: complexTopicsDisciplines.data.viewIsLoading,
  viewErrorStatus: complexTopicsDisciplines.data.viewErrorStatus,
});

const mapDispatchToProps = dispatch => ({
  getComplexTopicsDisciplineView: (id) => dispatch(getComplexTopicsDisciplineView(id)),
  clearComplexTopicsDisciplineView: () => dispatch(clearComplexTopicsDisciplineView()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ComplexTopicsDisciplinesView);
